import { type Control, Controller, type FieldPath, type FieldValues } from 'react-hook-form'
import { useIntl } from 'react-intl'

import { TextField } from '@/components/form'

import { couponErrorText } from './coupon-field-error'

type ControlledTextFieldProps<T extends FieldValues> = {
  control: Control<T>
  name: FieldPath<T>
  label: string
  helperText?: string
  disabled?: boolean
  maxLength?: number
  uppercase?: boolean
  'data-tst'?: string
}

/** Text field bound to a react-hook-form string field. */
export const ControlledTextField = <T extends FieldValues>({
  control,
  name,
  label,
  helperText,
  disabled,
  maxLength,
  uppercase = true,
  'data-tst': dataTst,
}: ControlledTextFieldProps<T>) => {
  const { formatMessage } = useIntl()

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <TextField
          ref={field.ref}
          data-tst={dataTst}
          disabled={disabled}
          error={couponErrorText(formatMessage, fieldState.error)}
          helperText={helperText}
          label={label}
          maxLength={maxLength}
          name={field.name}
          value={field.value}
          onBlur={field.onBlur}
          onChange={(e) =>
            field.onChange(uppercase ? e.target.value.toUpperCase() : e.target.value)
          }
        />
      )}
    />
  )
}
